export const GET_TYPE_CONFIGURATION = 'GET_TYPE_CONFIGURATION'
export const GET_TYPE_CONFIGURATION_EXITO = 'GET_TYPE_CONFIGURATION_EXITO'
export const GET_TYPE_CONFIGURATION_ERRROR = 'GET_TYPE_CONFIGURATION_ERROR'
